<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">CRM</a>
  </div>
  <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
  <nb-actions size="small">

    <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action> -->
    
    <nb-action class="control-item">
      <ng-container *ngIf="translate.currentLang == 'es'">
        <img src='../../../../assets/images/es-color.png' (click)="useLanguage('es')" />
      </ng-container>
      <ng-container *ngIf="translate.currentLang == 'en'">
        <img src='../../../../assets/images/es-grey.png' (click)="useLanguage('es')" />
      </ng-container>
    </nb-action>
    <nb-action class="control-item right">
      <ng-container *ngIf="translate.currentLang == 'es'">
        <img src='../../../../assets/images/en-grey.png' (click)="useLanguage('en')" />
      </ng-container>
      <ng-container *ngIf="translate.currentLang == 'en'">
        <img src='../../../../assets/images/en-color.png' (click)="useLanguage('en')" />
      </ng-container>
    </nb-action>

    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.first_name + ' ' + user?.last_name"
               [picture]="profileSrc + user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
